"use client";
import { Card } from "@heroui/react";
import Image from "next/image";


import HeroContent from "./hero-content";
import HeroImages from "./hero-images";
import { useTranslations } from "next-intl";

const HERO_SECTION_ID = "hero-section";
const HERO_HEADING_ID = "hero-section-heading";

export default function HeroSection() {
  const t = useTranslations("");

  const content = {
    title: t("home.intro.title"),
    description: t("home.intro.description"),
  };

  const images = {
    primaryImage: {
      src: "/img/main-page/hero-section-img.webp",
      alt: t("home.intro.title"),
    },
  };

  return (
    <section
      aria-labelledby={HERO_HEADING_ID}
      className="relative z-0 -mt-75 w-full overflow-hidden pt-75 pb-16 md:pb-20 lg:h-screen lg:pb-0"
      id={HERO_SECTION_ID}
    >
      <Image
        aria-hidden
        fill
        priority
        alt=""
        className="object-cover dark:hidden"
        fetchPriority="high"
        sizes="100vw"
        src="/img/header.svg"
      />
      <Image
        aria-hidden
        fill
        priority
        alt=""
        className="hidden object-cover dark:block"
        fetchPriority="high"
        sizes="100vw"
        src="/img/header-dark.svg"
      />

      <div className="relative z-10 container mx-auto h-full px-6">
        <Card className="flex flex-col justify-between gap-8 bg-transparent py-6 shadow-none md:h-150 md:flex-row md:p-8 md:py-8 lg:p-10">
          <HeroContent
            description={content.description}
            headingId={HERO_HEADING_ID}
            title={content.title}
          />
          <HeroImages images={images} />
        </Card>
      </div>
    </section>
  );
}
